module.exports = __webpack_public_path__ + "media/images/gifts/movement/sug_movimento_4-deb68e086348f50f974c23e5bbd4489c.jpg";